/**
 * src/data/fundLogos.js — logo của từng nguồn vốn, dùng trên trang danh mục
 * /nguon-von và trang chi tiết quỹ.
 *
 * Quyết định 20/10/2026: hiện logo trên trang, NHƯNG KHÔNG đưa vào ảnh chia sẻ
 * (xem src/data/fundImages.js). Logo giữ nguyên bản gốc lấy từ website chính
 * thức của đơn vị: không đổi màu, không cắt. Đơn vị yêu cầu gỡ thì xoá dòng ở đây.
 *
 * Thêm logo: lưu file vào public/logo-quy/<slug>.<svg|png|webp>, rồi thêm một
 * dòng slug: "tên file" bên dưới. Quỹ không có dòng nào thì hiện ô chữ cái đầu.
 */
export const LOGO_QUY = {
  "touchstone-partners": "touchstone-partners.svg",
  "beenext": "beenext.png",
  "ascend-vietnam-ventures": "ascend-vietnam-ventures.svg",
  "cocoon-capital": "cocoon-capital.svg",
  "kk-fund": "kk-fund.png",
  "monks-hill-ventures": "monks-hill-ventures.svg",
  "febe-ventures": "febe-ventures.svg",
  "b-capital-early": "b-capital.svg",
  "b-capital-growth": "b-capital.svg",
  "quest-ventures": "quest-ventures.png",
  "iterative": "iterative.webp",
  "jenfi": "jenfi.png",
  "golden-gate-ventures": "golden-gate-ventures.png",
  "500-global-vietnam": "500-global-vietnam.png",
  "beacon-fund": "beacon-fund.png",
  "hcm-vif": "hcm-vif.png",
  "smedf": "smedf.png",
  "angelcentral-vietnam": "angelcentral-vietnam.png",
  "cyberagent-capital": "cyberagent-capital.png",
  "vsv-capital": "vsv-capital.png",
  "genai-fund": "genai-fund.png",
  "aiviet-venture": "aiviet-venture.png",
  "mynavi": "mynavi.png",
  "2080-ventures": "2080-ventures.png",
  "tin-men-capital": "tin-men-capital.svg",
  "tvs-chung-khoan-thien-viet": "tvs-chung-khoan-thien-viet.svg",
};

export function logoQuy(slug) {
  const f = LOGO_QUY[slug];
  return f ? `/logo-quy/${f}` : null;
}
